module.exports = __webpack_public_path__ + "static/media/Sales3.dc9787d6.png";